<template>
  <label class="selector">
    <select v-model="selected" @change="changeFilter">
      <option
        v-for="(filter, index) in filterItem.seasonItemList"
        :value="filter.id"
        :key="`season_filter_${index}`"
      >
        {{ filter.title }}
      </option>
    </select>
  </label>
</template>
<script>
import { findIndex, get, assign } from 'lodash'
import { parseUrl, stringify } from 'query-string'
import { PATH_NAME_PLAYER } from '@/common/router.const'

export default {
  name: 'VodFilterList',
  data () {
    return {
      selected: ''
    }
  },
  props: {
    currentSeason: {
      type: String,
      default: ''
    },
    filterItem: {
      type: Object
    },
    baseApi: {
      type: String
    }
  },
  methods: {
    /**
     * 필터 변경
     */
    changeFilter () {
      const selectedIndex = findIndex(get(this.filterItem, 'seasonItemList', []), { 'id': this.selected })
      const selectedFilterItem = get(this.filterItem, ['seasonItemList', selectedIndex], {})
      const { id = '' } = selectedFilterItem
      let api = this.baseApi.replace('{id}', id)
      const { url, query } = parseUrl(api)
      const newQuery = assign({}, query)
      console.log('eventbus =>', url + '?' + stringify(newQuery), url, query)
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section: 'vod'
        },
        query: {
          programid: query.programid,
          history: query.history
        }
      })
    },

    /**
     * 셀렉트된 필터 출력
     */
    setSelected () {
      this.initialSelectedIndex = findIndex(this.filterItem.seasonItemList, { 'id': this.currentSeason })
      this.selected = get(this.filterItem, ['seasonItemList', this.initialSelectedIndex, 'id'], '')
    }
  },
  created () {
    this.setSelected()
  }
}
</script>
